'use client';

import { Study } from '@/lib/study';
import { T } from '@/lib/tokens';
import { Nav, StepHead, StepWrap } from '../StepShell';
import { Textarea } from '../Textarea';

type Props = {
  data: Study;
  setData: (d: Study) => void;
  onBack: () => void;
  onNext: () => void;
};

export function Step4Background({ data, setData, onBack, onNext }: Props) {
  return (
    <StepWrap>
      <StepHead
        label="Step 5 — Background"
        title="Any context the AI should know?"
        subtitle="Optional. Share anything that might help the AI conduct a better interview — your institution, study context, participant criteria, or sensitive topics to handle with care."
      />
      <Textarea
        value={data.background}
        onChange={(v) => setData({ ...data, background: v })}
        rows={6}
        placeholder="e.g. This study is run by Columbia Business School. Participants are adults who have used an AI companion app (such as Replika, Character.ai, or similar) for at least one month. Please be sensitive around topics of loneliness or mental health..."
      />
      <div
        style={{
          background: T.sageLight,
          border: `1px solid ${T.sage}`,
          borderRadius: 10,
          padding: '12px 16px',
          fontSize: 13,
          color: T.espressoMid,
        }}
      >
        This step is optional. You can skip it and continue.
      </div>
      <Nav onBack={onBack} onNext={onNext} />
    </StepWrap>
  );
}
